import Box from "@mui/material/Box";
import type { PidStatus } from "@shared/types/domain";

const STATUS_CONFIG: Record<
  PidStatus,
  { label: string; bg: string; color: string; dot: string }
> = {
  processing: {
    label: "Processing",
    bg: "#FFF3E0",
    color: "#E65100",
    dot: "#FF9800",
  },
  required_spof_review: {
    label: "Req. SPOF Review",
    bg: "#F3E5F5",
    color: "#6A1B9A",
    dot: "#AB47BC",
  },
  verification: {
    label: "Verification",
    bg: "#E8F4FD",
    color: "#006BA6",
    dot: "#009DE0",
  },
  spof_approval: {
    label: "SPOF Approval",
    bg: "#FFF8E1",
    color: "#B8860B",
    dot: "#FFB800",
  },
  approved: {
    label: "Approved",
    bg: "#E8F5E9",
    color: "#2E7D32",
    dot: "#43A047",
  },
  error: {
    label: "Error",
    bg: "#FFEBEE",
    color: "#C62828",
    dot: "#E30613",
  },
};

const FALLBACK = {
  label: "Unknown",
  bg: "#F0F2F5",
  color: "#5C6B7A",
  dot: "#8E99A8",
};

const badgeSx = (bg: string, color: string, dot: string) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "8px",
  py: "2px",
  borderRadius: "999px",
  bgcolor: bg,
  color,
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.02em",
  whiteSpace: "nowrap" as const,
  "&::before": {
    content: '""',
    display: "block",
    width: 6,
    height: 6,
    borderRadius: "50%",
    bgcolor: dot,
    flexShrink: 0,
  },
});

export const OPENABLE_STATUSES = new Set<PidStatus>([
  "error",
  "required_spof_review",
  "verification",
  "spof_approval",
  "approved",
]);

export function StatusChip({ status }: { status: PidStatus }) {
  const cfg = STATUS_CONFIG[status] ?? FALLBACK;
  return (
    <Box component="span" sx={badgeSx(cfg.bg, cfg.color, cfg.dot)}>
      {cfg.label}
    </Box>
  );
}

export function StatusChipFromSummary({
  status,
  percentage,
}: {
  status: PidStatus | null;
  percentage: number;
}) {
  if (!status) return null;
  const cfg = STATUS_CONFIG[status] ?? FALLBACK;
  return (
    <Box component="span" sx={badgeSx(cfg.bg, cfg.color, cfg.dot)}>
      {cfg.label} {percentage}%
    </Box>
  );
}
